import React, { useCallback, useEffect, useState } from "react";
import { customerServices } from "../../../../services/api";
import CustomPagination from "../../../UI/Pagination";
import PageError from "../../../CommonPage/PageError";
import PageLoading from "../../../CommonPage/PageLoading";
import PageNoData from "../../../CommonPage/PageNoData";
import { toast } from "react-toastify";
import TransactionHistoryTable from "./TransactionHistoryTable";
import messages from "../../../../services/api/messages";
import { useSearchParams, useLocation } from "react-router-dom";

function CustomerDetailTransactionHistory(props) {
  const [searchParams] = useSearchParams();

  const quotationId = searchParams.get("quotationId");
  const planId = searchParams.get("planId");
  const requestId = searchParams.get("requestId");
  const sampleId = searchParams.get("sampleId");
  const reportId = searchParams.get("reportId");
  const invoiceId = searchParams.get("invoiceId");
  const caseId = searchParams.get("caseId");
  const location = useLocation();
  const notificationClickedAt = location.state?.notificationClickedAt;
  const [loadInitState, setLoadInitState] = useState({
    isLoading: false,
    data: null,
    error: null,
  });
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalItems: 0,
    totalPages: 0,
  });
  
  const [lastNotificationTime, setLastNotificationTime] = useState(null);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  const loadInit = useCallback((page) => {
    setLoadInitState({
      isLoading: true,
      data: null,
      error: null,
    });

    customerServices
      .getCaseList(page)
      .then((res) => {
        setPagination({
          currentPage: Number(res.data.result.page),
          totalItems: Number(res.data.result.total),
          totalPages: Number(res.data.result.totalPages),
        });

        setLoadInitState({
          isLoading: false,
          data: res.data.result.rows,
          error: null,
        });
      })
      .catch((error) => {
        toast.error(messages.downloadFail);
        setLoadInitState({
          isLoading: false,
          data: null,
          error: error,
        });
      });
  }, []);
  useEffect(() => {
    const ids = [quotationId, planId, requestId, sampleId, reportId, invoiceId, caseId];
    const hasAnyId = ids.some(id => id);
    const isNewNotification = notificationClickedAt !== lastNotificationTime;
    if (!isFirstLoad && !isNewNotification) {
      return;
    }
    const initialize = async () => {
      try {
        setLoadInitState({
          isLoading: true,
          data: null,
          error: null,
        });
        
        const firstPageRes = await customerServices.getCaseList(1);
        const totalPages = Number(firstPageRes.data.result.totalPages);
        
        let targetPage = 1;
        
        if (hasAnyId) {
          for (let page = 1; page <= totalPages; page++) {
            const res = await customerServices.getCaseList(page);
            const items = res.data.result.rows;

            const foundItem = items.find(item =>
              ids.some(id => id && (id === item._id || id === item.caseId))
            );

            if (foundItem) {
              targetPage = page;
              break;
            }
          }
        }
        const finalRes = await customerServices.getCaseList(targetPage);
        if (targetPage !== pagination.currentPage) {
          setIsFirstLoad(true);
        }
        setPagination({
          currentPage: Number(finalRes.data.result.page),
          totalItems: Number(finalRes.data.result.total),
          totalPages: Number(finalRes.data.result.totalPages),
        });

        setLoadInitState({
          isLoading: false,
          data: finalRes.data.result.rows,
          error: null,
        });
        
        setLastNotificationTime(notificationClickedAt);

      } catch (error) {
        console.error("Error during initialization:", error);
        toast.error(messages.downloadFail);
        setLoadInitState({
          isLoading: false,
          data: null,
          error: error,
        });
        setIsFirstLoad(false);
      }
    };

    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quotationId, planId, requestId, sampleId, reportId, invoiceId, caseId, notificationClickedAt]);

  useEffect(() => {
    if (!isFirstLoad) {
      loadInit(pagination.currentPage);
    }
    setIsFirstLoad(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage, loadInit]);

  const handleChangePage = (newPage) => {
    setPagination((oldState) => ({
      ...oldState,
      currentPage: newPage,
    }));
  };

  return (
    <div className="w-full h-auto">
      <div className="w-full h-auto">
        {loadInitState.isLoading ? (
          <div className="w-full h-[240px] overflow-x-auto">
            <PageLoading />
          </div>
        ) : null}

        {!loadInitState.isLoading && loadInitState.error ? <PageError /> : null}

        {!loadInitState.isLoading &&
        !loadInitState.error &&
        Array.isArray(loadInitState.data) ? (
          loadInitState.data.length > 0 ? (
            <div className="w-full h-[240px] overflow-x-auto">
              <TransactionHistoryTable
                initCaseList={loadInitState.data}
              />
            </div>
          ) : (
            <PageNoData noDataMessage="データなし!" noDataAction />
          )
        ) : null}
      </div>

      <div className="w-full h-auto">
        {pagination.totalItems > 0 ? (
          <CustomPagination
            currentPage={pagination.currentPage}
            totalItems={pagination.totalItems}
            handleChangePage={handleChangePage}
          />
        ) : null}
      </div>
    </div>
  );
}

export default CustomerDetailTransactionHistory;
